import Model from "../Model";

class Representantclientidtops extends Model{

    buildUrl ({ param }) {
        return ['employeeclientview/topuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Representantclientidtops;